var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "modals-container" } },
    _vm._l(_vm.modals, function (modal) {
      return _c(
        "modal",
        _vm._g(
          _vm._b(
            {
              key: modal.id,
              on: {
                closed: function ($event) {
                  return _vm.remove(modal.id)
                },
              },
            },
            "modal",
            modal.modalAttrs,
            false
          ),
          modal.modalListeners
        ),
        [
          _c(
            modal.component,
            _vm._g(
              _vm._b(
                {
                  tag: "component",
                  on: {
                    close: function ($event) {
                      return _vm.$modal.hide(modal.modalAttrs.name, $event)
                    },
                  },
                },
                "component",
                modal.componentAttrs,
                false
              ),
              _vm.$listeners
            )
          ),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }